import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import "../videopost/VideoPost.css";
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
// import businessicon from '../../assets/home-images/businessicon.jpg';
import Navbar from "../common-component/navbar/Navbar";
// import plusicon from '../../assets/home-images/plusicon.png';
// import messageicon from '../../assets/home-images/messageicon.png';
// import bellicon from '../../assets/home-images/bellicon.png';
// import profileicon from '../../assets/home-images/profileicon.png';
// import search from '../../assets/home-images/search.png';
// import videos from '../../assets/home-images/videos.png';
// import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
// import menu from '../../assets/home-images/menu.png';
// import downarrow from '../../assets/home-images/downarrow.png';
import campopup from '../../assets/home-images/cam-popup.png';
import vidpopup from '../../assets/home-images/vid-popup.png';
import offerpopup from '../../assets/home-images/offer-popup.png';
import eventpopup from '../../assets/home-images/event-popup.png';
import spotlightpopup from '../../assets/home-images/spotlight-popup.png';
import carouselpopup from '../../assets/home-images/carouselpopup.png';
import videomute from "../../assets/home-images/mid-section-images/videomute.png";
import videounmute from "../../assets/home-images/mid-section-images/videounmute.png";
import hearticon from '../../assets/home-images/mid-section-images/hearticon.png';
import commenticon from '../../assets/home-images/mid-section-images/commenticon.png';
import shareicon from '../../assets/home-images/mid-section-images/shareicon.png';
import threedot from '../../assets/home-images/mid-section-images/threedot.png';
// import viewreplyicon from "../../assets/home-images/mid-section-images/viewreplyicon.png";
import linkicon from "../../assets/home-images/mid-section-images/linkicon.png";
import emoji from "../../assets/home-images/mid-section-images/emoji.png";
import axios from "axios";
import { BACKEND_URL, fastApiCall, fastApiClient } from "../common/Common";
import Hls from 'hls.js';
import popup_yatch from "../../assets/offers/popup_yatch.png";

import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import LeftSection from "../common-component/left-menu-section/LeftSection";

const VideoPost = () => {
    // const { id } = useParams();
    const [postpopup, setPostpopup] = useState(false);
    const popupRef = useRef(null);
    const location = useLocation();
    const { postData } = location.state || {};

    const [allVideos, setAllVideos] = useState([]);
    const [videoComments, setVideoComments] = useState({});
    const [globalMute, setGlobalMute] = useState(true);
    // const videoRefs = useRef({});
    const mainSectionRef = useRef(null);
    const selectedVideoRef = useRef(null);
    // const [descExpanded, setDescExpanded] = useState(false);
    const isRefreshedRef = useRef(false);
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);
    const [activeVideoIndex, setActiveVideoIndex] = useState(null);
    const [expand, setExpand] = useState({});
    const videoRefs = useRef({}); // Store video element refs for cleanup
    const hlsInstances = useRef({}); // Store HLS instances for cleanup
    const [initializedVideos, setInitializedVideos] = useState(new Set()); // Track initialized videos
    const [isLoading, setIsLoading] = useState(true); // Track initial loading state
    const [loadingComments, setLoadingComments] = useState(new Set()); // Track which comments are loading

    // Fisher-Yates shuffle algorithm
    const shuffleArray = (array) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    // Cleanup HLS instance
    const cleanupVideo = useCallback((videoIndex) => {
        if (hlsInstances.current[videoIndex]) {
            hlsInstances.current[videoIndex].destroy();
            delete hlsInstances.current[videoIndex];
        }
        if (videoRefs.current[videoIndex]) {
            const el = videoRefs.current[videoIndex];
            if (el.hlsInstance) {
                el.hlsInstance.destroy();
                el.hlsInstance = null;
            }
            el.pause();
            el.src = '';
            el.load();
        }
    }, []);

    const fetchCommentsByPostId = useCallback(async (postId) => {
        try {
            setLoadingComments(prev => new Set([...prev, postId]));
            const response = await axios.post(`${BACKEND_URL}website/get-post-comments`, {
                login_user_id: 501,
                post_id: postId,
            });
            setVideoComments(prev => ({
                ...prev,
                [postId]: response.data
            }));
        } catch (error) {
            console.error("Error fetching comments:", error);
            setVideoComments(prev => ({
                ...prev,
                [postId]: []
            }));
        } finally {
            setLoadingComments(prev => {
                const newSet = new Set(prev);
                newSet.delete(postId);
                return newSet;
            });
        }
    }, []);

    // Helper function to process videos from API response
    const processVideosFromResponse = useCallback((responseData) => {
        // Handle normal_post - filter for videos only
        const normalVideos = Array.isArray(responseData.normal_post)
            ? responseData.normal_post.filter(post => post.video_file)
            : [];

        console.log("Video response data ===", responseData);
        
        // Handle videos_for_you - can be array or object with posts property
        let shortVideos = [];
        if (Array.isArray(responseData.videos_for_you)) {
            shortVideos = responseData.videos_for_you.filter(post => post.video_file);
        } else if (responseData.videos_for_you && responseData.videos_for_you.posts) {
            shortVideos = Array.isArray(responseData.videos_for_you.posts)
                ? responseData.videos_for_you.posts.filter(post => post.video_file)
                : [];
        }

        return { normalVideos, shortVideos };
    }, []);

    // Helper function to deduplicate videos
    const deduplicateVideos = useCallback((videos) => {
        const uniqueVideos = [];
        const seenIds = new Set();
        const seenFiles = new Set();

        videos.forEach(video => {
            const id = video.id || video.post_id || video.coupon_id;
            const file = video.video_file ? video.video_file.split('/').pop() : null;

            const idKey = id ? String(id) : null;
            const fileKey = file || null;

            // Check if this video is a duplicate
            const isDuplicate = (idKey && seenIds.has(idKey)) || (fileKey && seenFiles.has(fileKey));

            if (!isDuplicate) {
                uniqueVideos.push(video);
                if (idKey) seenIds.add(idKey);
                if (fileKey) seenFiles.add(fileKey);
            }
        });

        return uniqueVideos;
    }, []);

    // Helper to check if video matches postData
    const videoMatchesPostData = useCallback((video, postData) => {
        if (!postData) return false;
        if (video.id && postData.id && String(video.id) === String(postData.id)) return true;
        if (video.video_file && postData.video_file) {
            const videoFile1 = video.video_file.split('/').pop();
            const videoFile2 = postData.video_file.split('/').pop();
            if (video.video_file === postData.video_file || videoFile1 === videoFile2) return true;
        }
        if (video.coupon_id && postData.coupon_id && String(video.coupon_id) === String(postData.coupon_id)) return true;
        if (video.post_id && postData.post_id && String(video.post_id) === String(postData.post_id)) return true;
        if (video.user_id && postData.user_id && String(video.user_id) === String(postData.user_id)) {
            if (video.video_file && postData.video_file) {
                const videoFile1 = video.video_file.split('/').pop();
                const videoFile2 = postData.video_file.split('/').pop();
                if (videoFile1 === videoFile2) return true;
            }
        }
        return false;
    }, []);

    // Load more videos in background (non-blocking)
    const loadMoreVideosInBackground = useCallback(async (existingVideos = []) => {
        const MAX_PAGES = 50;
        const PER_PAGE = 100; // Larger batch size for background loading
        let currentPage = 2; // Start from page 2 (page 1 already loaded)
        let allNormalVideos = [];
        let allShortVideos = [];
        let hasMoreData = true;
        let selectedVideoFound = !isRefreshedRef.current && postData &&
            existingVideos.some(v => videoMatchesPostData(v, postData));

        // Process existing videos to separate normal and short
        existingVideos.forEach(video => {
            // We can't determine type from existing videos, so we'll add them all to combined list later
        });

        try {
            while (hasMoreData && currentPage <= MAX_PAGES) {
                const response = await fastApiClient.post(`${BACKEND_URL}website/get-post-list`, {
                    login_user_id: 501,
                    per_page: PER_PAGE,
                    page: currentPage,
                });

                console.log("Request payload:", {
                    login_user_id: 501,
                    per_page: PER_PAGE,
                    page: currentPage,
                });

                const { normalVideos, shortVideos } = processVideosFromResponse(response.data);
                allNormalVideos = [...allNormalVideos, ...normalVideos];
                allShortVideos = [...allShortVideos, ...shortVideos];
                
                const totalVideosFromPage = normalVideos.length + shortVideos.length;
                hasMoreData = totalVideosFromPage > 0;

                // If searching for selected video, check if it's in this batch
                if (!selectedVideoFound && !isRefreshedRef.current && postData) {
                    const allNewVideos = [...normalVideos, ...shortVideos];
                    const selectedVideo = allNewVideos.find(v => videoMatchesPostData(v, postData));

                    if (selectedVideo) {
                        // Found selected video - update state immediately
                        setAllVideos(prevVideos => {
                            const filtered = prevVideos.filter(v => !videoMatchesPostData(v, postData));
                            const unique = deduplicateVideos([selectedVideo, ...filtered, ...allNormalVideos, ...allShortVideos]);
                            return unique;
                        });
                        selectedVideoFound = true;
                        hasMoreData = false; // Stop searching
                        break;
                    }
                }

                // Update videos list with new videos (deduplicated)
                setAllVideos(prevVideos => {
                    const combined = [...prevVideos, ...allNormalVideos, ...allShortVideos];
                    return deduplicateVideos(combined);
                });

                // Reset accumulators for next iteration
                allNormalVideos = [];
                allShortVideos = [];
                
                currentPage++;

                // Small delay to prevent blocking
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        } catch (error) {
            console.error("Error loading more videos:", error);
        }
    }, [processVideosFromResponse, deduplicateVideos, videoMatchesPostData, postData]);

    // Load first batch quickly and show immediately
    const fetchInitialVideos = useCallback(async () => {
        const INITIAL_BATCH_SIZE = 20; // Show first 20 videos immediately

        await fastApiCall(
            () => fastApiClient.post(`${BACKEND_URL}website/get-post-list`, {
                login_user_id: 501,
                per_page: INITIAL_BATCH_SIZE,
                page: 1,
            }),
            setIsLoading, // fastApiCall will hide loading immediately after response
            (data) => {
                // Process videos from first page
                const { normalVideos, shortVideos } = processVideosFromResponse(data);
                let combinedVideos = [...normalVideos, ...shortVideos];
                combinedVideos = deduplicateVideos(combinedVideos);

                if (combinedVideos.length === 0) {
                    console.log("No videos found");
                    setAllVideos([]);
                    return;
                }

                // If NOT a refresh AND we have a selected video from navigation, find and move it to first position
                if (!isRefreshedRef.current && postData) {
                    const selectedVideoIndex = combinedVideos.findIndex(
                        video => videoMatchesPostData(video, postData)
                    );

                    if (selectedVideoIndex !== -1) {
                        const selectedVideo = combinedVideos[selectedVideoIndex];
                        combinedVideos.splice(selectedVideoIndex, 1);
                        combinedVideos.unshift(selectedVideo);
                        console.log('Selected video found and moved to first position');
                    } else {
                        // Selected video not in first batch - will search in background
                        combinedVideos = shuffleArray(combinedVideos);
                    }
                } else {
                    combinedVideos = shuffleArray(combinedVideos);
                }

                setAllVideos(combinedVideos);

                // Fetch comments for the first video
                if (combinedVideos.length > 0 && combinedVideos[0].id) {
                    fetchCommentsByPostId(combinedVideos[0].id);
                }

                // Continue loading more videos in background (non-blocking)
                loadMoreVideosInBackground(combinedVideos);
            }
        ).catch(error => {
            console.error("Error fetching initial videos:", error);
            setAllVideos([]);
        });
    }, [processVideosFromResponse, deduplicateVideos, videoMatchesPostData, postData, fetchCommentsByPostId, loadMoreVideosInBackground]);

    // Legacy function name for compatibility
    const fetchAllVideos = fetchInitialVideos;

    useEffect(() => {
        // Check if this is a page refresh by checking sessionStorage
        const wasNavigated = sessionStorage.getItem('videopost_navigated');

        if (!wasNavigated) {
            // This is a refresh or direct visit
            isRefreshedRef.current = true;
        } else {
            // This is a navigation from another page
            isRefreshedRef.current = false;
            // Clear the flag
            sessionStorage.removeItem('videopost_navigated');
        }

        fetchAllVideos();

        // Clear fetch_all_videos flag after fetching
        sessionStorage.removeItem('fetch_all_videos');

        // Cleanup on unmount
        return () => {
            // Cleanup all HLS instances
            Object.keys(hlsInstances.current).forEach(index => {
                cleanupVideo(parseInt(index));
            });
            // Cleanup all video refs
            Object.keys(videoRefs.current).forEach(index => {
                const el = videoRefs.current[index];
                if (el) {
                    el.pause();
                    el.src = '';
                    el.load();
                }
            });
            videoRefs.current = {};
            hlsInstances.current = {};
        };
    }, [fetchAllVideos, cleanupVideo]);

    // Scroll to selected video after videos are loaded (only if not refreshed)
    useEffect(() => {
        if (allVideos.length > 0 && !isRefreshedRef.current && postData && selectedVideoRef.current) {
            setTimeout(() => {
                selectedVideoRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 500);
        }
    }, [allVideos, postData]);

    // Immediately ensure the first video plays if it's the selected one (fallback in case ref callback didn't work)
    useEffect(() => {
        if (allVideos.length > 0 && !isRefreshedRef.current && postData) {
            // Check if first video matches the selected video
            const firstVideo = allVideos[0];
            const isSelectedVideo =
                (firstVideo.id && postData.id && String(firstVideo.id) === String(postData.id)) ||
                (firstVideo.video_file && postData.video_file &&
                    (firstVideo.video_file === postData.video_file ||
                        firstVideo.video_file.split('/').pop() === postData.video_file.split('/').pop())) ||
                (firstVideo.coupon_id && postData.coupon_id && String(firstVideo.coupon_id) === String(postData.coupon_id)) ||
                (firstVideo.post_id && postData.post_id && String(firstVideo.post_id) === String(postData.post_id));

            if (isSelectedVideo) {
                // Set active video index immediately
                setActiveVideoIndex(0);

                // Wait a bit for DOM to be ready, then ensure video is playing
                const checkAndPlay = () => {
                    const firstVideoElement = document.querySelector('video[data-video-index="0"]');
                    if (firstVideoElement) {
                        // Ensure video is initialized and playing
                        if (initializedVideos.has(0)) {
                            firstVideoElement.muted = globalMute;
                            firstVideoElement.volume = globalMute ? 0 : 1;
                            if (firstVideoElement.paused) {
                                firstVideoElement.play().catch(err => {
                                    console.log('Play failed:', err);
                                });
                            }
                        } else {
                            // If not initialized yet, wait a bit more
                            setTimeout(checkAndPlay, 200);
                        }
                    }
                };

                // Try immediately and also after delays
                checkAndPlay();
                setTimeout(checkAndPlay, 300);
                setTimeout(checkAndPlay, 600);
                setTimeout(checkAndPlay, 1000);
            }
        }
    }, [allVideos, postData, initializedVideos, globalMute, isRefreshedRef]);

    // Initialize video with HLS - optimized for performance
    const initializeVideoPost = useCallback((el, videoUrl, videoIndex) => {
        if (!el || !videoUrl) return;

        // Don't initialize if already initialized
        if (el.dataset.hlsInitialized === 'true') return;

        // Store ref for cleanup
        videoRefs.current[videoIndex] = el;

        // Dynamically construct the proxy URL based on environment
        const backendBase = BACKEND_URL.replace('/api/', ''); // Get base URL without /api/

        // Extract just the filename from the video URL
        const filename = videoUrl.split('/').pop();

        // Construct the proxy URL dynamically
        const proxyUrl = `${backendBase}/video/${filename}`;

        // console.log('Loading video from:', proxyUrl); // Debug log

        const playMutedVideo = () => {
            // Always start muted (Instagram Reels behavior)
            // The mute/unmute button will control it later
            // The sync useEffect will update mute state when video becomes active
            el.muted = true;
            el.volume = 0;
            // el.play().catch(err => console.log('Autoplay prevented:', err));
        };

        // Optimized HLS configuration for better performance
        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                backBufferLength: 10, // Reduced from 90 to 10
                maxBufferLength: 10, // Reduced from 30 to 10
                maxMaxBufferLength: 20, // Reduced from 60 to 20
                maxBufferSize: 20 * 1000 * 1000, // Reduced from 60MB to 20MB
                startLevel: 0,
                autoStartLoad: true,
                progressive: true,
                capLevelToPlayerSize: true, // Auto-adjust quality to player size
                xhrSetup: function (xhr) {
                    xhr.withCredentials = false;
                    xhr.timeout = 8000; // Reduced from 10000 to 8000
                }
            });

            hls.loadSource(proxyUrl);
            hls.attachMedia(el);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                playMutedVideo();
            });

            hls.on(Hls.Events.ERROR, (event, data) => {
                console.error('HLS Error:', data); // Add error logging
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                }
            });

            el.dataset.hlsInitialized = 'true';
            el.hlsInstance = hls;
            hlsInstances.current[videoIndex] = hls;

            // Mark as initialized
            setInitializedVideos(prev => new Set([...prev, videoIndex]));

        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
            el.src = proxyUrl;
            playMutedVideo();
            el.dataset.hlsInitialized = 'true';
            setInitializedVideos(prev => new Set([...prev, videoIndex]));
        }

        el.dataset.videoIndex = videoIndex;
    }, []);
    const toggleMute = useCallback(() => {
        const newMuteState = !globalMute;
        setGlobalMute(newMuteState);

        // Apply mute state only to the currently active video
        const activeVideo = document.querySelector(`video[data-video-index="${activeVideoIndex}"]`);
        if (activeVideo) {
            activeVideo.muted = newMuteState;
            activeVideo.volume = newMuteState ? 0 : 1;
        }
    }, [globalMute, activeVideoIndex]);
    
    useEffect(() => {
        if (allVideos.length === 0) return;

        const videoObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const videoElement = entry.target;
                    const videoIndex = parseInt(videoElement.dataset.videoIndex);

                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        setActiveVideoIndex(videoIndex);

                        // Initialize video if not already initialized (lazy loading)
                        if (!initializedVideos.has(videoIndex) && allVideos[videoIndex]) {
                            initializeVideoPost(videoElement, allVideos[videoIndex].video_file, videoIndex);
                        }

                        // Fetch comments for visible video if not already fetched
                        if (allVideos[videoIndex]?.id && !videoComments[allVideos[videoIndex].id]) {
                            fetchCommentsByPostId(allVideos[videoIndex].id);
                        }

                        // Always start video muted (Instagram Reels behavior)
                        // The mute/unmute button will control this specific video
                        videoElement.muted = globalMute;
                        videoElement.volume = globalMute ? 0 : 1;

                        // Play video
                        videoElement.play().catch(err => {
                            // console.log('Play failed:', err);
                        });

                        // Pause all other videos and ensure they're muted
                        document.querySelectorAll('video[data-video-index]').forEach(otherVideo => {
                            const otherIndex = parseInt(otherVideo.dataset.videoIndex);
                            if (otherVideo !== videoElement && otherIndex !== videoIndex) {
                                otherVideo.pause();
                                otherVideo.muted = true;
                                otherVideo.volume = 0;
                            }
                        });
                    } else {
                        // Pause video when not visible and mute it
                        videoElement.pause();
                        videoElement.muted = true;
                        videoElement.volume = 0;
                    }
                });
            },
            {
                threshold: 0.5,
                rootMargin: '50px' // Start loading slightly before video is visible
            }
        );

        const observeVideos = () => {
            document.querySelectorAll('video[data-video-index]').forEach((video) => {
                videoObserver.observe(video);
            });
        };

        observeVideos();

        const observer = new MutationObserver(observeVideos);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            videoObserver.disconnect();
            observer.disconnect();
        };
    }, [allVideos, initializedVideos, videoComments, initializeVideoPost, fetchCommentsByPostId, globalMute]);

    // Sync mute state with active video when globalMute changes or when active video changes
    useEffect(() => {
        if (activeVideoIndex !== null) {
            const activeVideo = document.querySelector(`video[data-video-index="${activeVideoIndex}"]`);
            if (activeVideo) {
                // Apply the current global mute state to the active video
                activeVideo.muted = globalMute;
                activeVideo.volume = globalMute ? 0 : 1;
            }
        }
    }, [globalMute, activeVideoIndex]);

    // Shimmer skeleton component for video post
    const VideoPostShimmer = () => (
        <div className="video-post-container shimmer-container">
            <div className="left-side-video-container">
                <div className="shimmer shimmer-video"></div>
            </div>
            <div className="right-side-post-details-container">
                <div className="video-post-details-section">
                    <div className="video-post-header">
                        <div className="post-profile-info">
                            <div className="shimmer shimmer-avatar"></div>
                            <div className="username-state-follower-div">
                                <div className="shimmer shimmer-text shimmer-username"></div>
                                <div className="shimmer shimmer-text shimmer-state"></div>
                            </div>
                        </div>
                        <div className="shimmer shimmer-button"></div>
                    </div>
                </div>
                <div className="scroll-y">
                    <div className="video-post-description">
                        <div className="shimmer shimmer-text shimmer-description"></div>
                        <div className="shimmer shimmer-text shimmer-description shimmer-description-short"></div>
                    </div>
                    <div className="video-post-comment-input">
                        <div className="shimmer shimmer-input"></div>
                    </div>
                    <div className="video-post-comments">
                        {[1, 2, 3].map((i) => (
                            <div className="comment-item" key={i}>
                                <div className="shimmer shimmer-avatar shimmer-comment-avatar"></div>
                                <div className="comment-content" style={{ flex: 1 }}>
                                    <div className="shimmer shimmer-text shimmer-comment-header"></div>
                                    <div className="shimmer shimmer-text shimmer-comment-text"></div>
                                    <div className="shimmer shimmer-text shimmer-comment-actions"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );

    if (isLoading || allVideos.length === 0) {
        return (
            <div>
                <Navbar />
                <div className="experience-main-layout">
                    <LeftSection />
                    <main className="video-post-main-section">
                        {[1, 2, 3].map((i) => (
                            <VideoPostShimmer key={i} />
                        ))}
                    </main>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Navbar />
            <div className="experience-main-layout">
                {/* <aside className="left-section">
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input type="text" placeholder="Search..." />
                    </div>
                    <div className="left-menu-content">
                        <Link
                            to="/videoposts"
                            className="remove-underline"
                        >
                            <div className="img-contentname">
                                <img src={videos} alt="videos" />
                                <p>Videos for you</p>
                            </div>
                        </Link>
                        <div className="img-contentname">
                            <img src={blogs} alt="blogs" />
                            <p>Blogs</p>
                        </div>
                        <div className="img-contentname">
                            <img src={save} alt="save" />
                            <p>Saved</p>
                        </div>
                        <div className="img-contentname">
                            <img src={profileicon} alt="profileicon" />
                            <p>Profile</p>
                        </div>
                        <div className="img-contentname">
                            <img src={plusicon} alt="plusicon" />
                            <p>Post</p>
                        </div>
                        <div className="img-contentname">
                            <img src={menu} alt="menu" />
                            <p>Menu</p>
                        </div>
                    </div>
                    <div className="divider-line"></div>
                    <div className="left-bottom-links">
                        <div className="left-bottom1">
                            <a href="/about">About</a>
                            <a href="#BusinessPro">Business Pro</a>
                        </div>
                        <div className="left-bottom1">
                            <a href="#help-center">Help Center</a>
                            <a href="#FAQ">FAQ</a>
                            <a href="#Careers">Careers</a>
                        </div>
                        <div className="left-bottom1">
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                            <div className="content-arrow">
                                <a href="#Languages">Language</a>
                                <img src={downarrow} alt="downarrow" />
                            </div>
                        </div>
                    </div>
                </aside> */}
                <LeftSection />
                <main className="video-post-main-section" ref={mainSectionRef}>
                    {allVideos.map((video, index) => {
                        const isFirstVideo = index === 0 && !isRefreshedRef.current && postData;
                        const comments = videoComments[video.id] || [];

                        return (
                            <div
                                key={video.id || index}
                                className="video-post-container"
                                ref={isFirstVideo ? selectedVideoRef : null}
                            >
                                <div className="left-side-video-container">
                                    {video.video_file ? (
                                        <>
                                            <video
                                                ref={(el) => {
                                                    // Initialize first video immediately, others will be lazy loaded
                                                    if (el && index === 0 && !initializedVideos.has(0)) {
                                                        // Check if this is the selected video before initializing
                                                        const isSelectedVideo = !isRefreshedRef.current && postData && (
                                                            (video.id && postData.id && String(video.id) === String(postData.id)) ||
                                                            (video.video_file && postData.video_file &&
                                                                (video.video_file === postData.video_file ||
                                                                    video.video_file.split('/').pop() === postData.video_file.split('/').pop())) ||
                                                            (video.coupon_id && postData.coupon_id && String(video.coupon_id) === String(postData.coupon_id)) ||
                                                            (video.post_id && postData.post_id && String(video.post_id) === String(postData.post_id))
                                                        );

                                                        if (isSelectedVideo) {
                                                            setActiveVideoIndex(0);
                                                            console.log('Initializing selected video at index 0');
                                                        }

                                                        // Always initialize first video (whether selected or not)
                                                        initializeVideoPost(el, video.video_file, index);
                                                    }
                                                }}
                                                poster={video.video_cover_picture || ''}
                                                loop
                                                playsInline
                                                muted
                                                preload={index === 0 ? "auto" : "none"} // Only preload first video
                                                onClick={(e) => {
                                                    if (e.currentTarget.paused) {
                                                        e.currentTarget.play();
                                                    } else {
                                                        e.currentTarget.pause();
                                                    }
                                                }}
                                                disablePictureInPicture
                                                data-video-index={index}
                                            />
                                            <div className="video-post-mute-button" onClick={toggleMute}>
                                                {globalMute ? (
                                                    <img src={videomute} alt="video mute" title="Unmute" />
                                                ) : (
                                                    <img src={videounmute} alt="video unmute" title="Mute" />
                                                )}
                                            </div>

                                            <div className="video-post-actions">
                                                <div className="feed-actions">
                                                    <div className="action-item">
                                                        <img src={hearticon} alt="heart icon" className="heart" onClick={() => setDownloadPopupOpen(true)} />
                                                        <span>{video.likes > 0 ? video.likes : ''}</span>

                                                        <p className="action-divider">|</p>

                                                        <img src={commenticon} alt="comment icon" className="comment" onClick={() => setDownloadPopupOpen(true)} />
                                                        <span>{video.comments_count > 0 ? video.comments_count : ''}</span>

                                                        <p className="action-divider">|</p>

                                                        <img src={shareicon} alt="share" onClick={() => setDownloadPopupOpen(true)} />
                                                    </div>
                                                </div>

                                                <div className="action-item">
                                                    <img src={save} alt="save" onClick={() => setDownloadPopupOpen(true)} />
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '500px' }}>
                                            <p>Loading video...</p>
                                        </div>
                                    )}
                                </div>

                                <div className="right-side-post-details-container">
                                    <div className="video-post-details-section">
                                        <div className="video-post-header">
                                            <div className="post-profile-info">
                                                <Link
                                                    to={`/vendordetails/${video.user_id}`}
                                                    className="remove-underline"
                                                >
                                                    <img src={video.user_image} alt="profile" className="profile-avatar" />
                                                </Link>

                                                <div className="username-state-follower-div">
                                                    <Link to={`/vendordetails/${video.user_id}`} className="remove-underline">
                                                        <h4>{video.user_name}</h4>
                                                    </Link>
                                                    <p>
                                                        {video.state}
                                                        {/* {video.following > 0 && ` | ${video.following} Followers`} */}
                                                    </p>

                                                </div>
                                            </div>
                                            <div className="header-right">
                                                <button className="post-detail-follow-btn" onClick={() => setDownloadPopupOpen(true)}>Follow</button>
                                                <img src={threedot} alt="menu" onClick={() => setDownloadPopupOpen(true)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="scroll-y">
                                        <div className="video-post-description">
                                            <div className="feed-caption">
                                                {video.description && (() => {
                                                    // const descLimit = 60; // adjust as needed for mobile/desktop
                                                    const descTruncateLength = 180;
                                                    const shouldTruncate = video.description.length > descTruncateLength;
                                                    const isExpanded = expand[video.id];

                                                    return (
                                                        <p className={`feed-caption-text ${isExpanded ? "expanded" : ""}`}>
                                                            {isExpanded
                                                                ? video.description
                                                                : shouldTruncate
                                                                    ? `${video.description.substring(0, descTruncateLength)}... `
                                                                    : video.description
                                                            }

                                                            {shouldTruncate && (
                                                                <span
                                                                    className="feed-caption-toggle"
                                                                    onClick={() =>
                                                                        setExpand(prev => ({
                                                                            ...prev,
                                                                            [video.id]: !prev[video.id]
                                                                        }))
                                                                    }
                                                                >
                                                                    {isExpanded ? "Less" : "More"}
                                                                </span>
                                                            )}
                                                        </p>
                                                    );
                                                })()}
                                            </div>
                                        </div>

                                        <div className="video-post-comment-input">
                                            <div className="comment-input-wrapper" onClick={() => setDownloadPopupOpen(true)}>
                                                <input type="text" placeholder="Share your thoughts..." />

                                                <div className="comment-icons">
                                                    <img src={linkicon} alt="link icon" />
                                                    <img src={emoji} alt="emoji icon" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="video-post-comments">
                                            {loadingComments.has(video.id) ? (
                                                [1, 2, 3].map((i) => (
                                                    <div className="comment-item" key={i}>
                                                        <div className="shimmer shimmer-avatar shimmer-comment-avatar"></div>
                                                        <div className="comment-content" style={{ flex: 1 }}>
                                                            <div className="shimmer shimmer-text shimmer-comment-header"></div>
                                                            <div className="shimmer shimmer-text shimmer-comment-text"></div>
                                                            <div className="shimmer shimmer-text shimmer-comment-actions"></div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : comments && comments.length > 0 ? (
                                                comments.map((item, idx) => (
                                                    <div className="comment-item" key={idx}>
                                                        {item.user_image ? (
                                                            <img
                                                                src={item.user_image}
                                                                alt="commenter"
                                                                className="comment-avatar"
                                                            />
                                                        ) : (
                                                            <div
                                                                className="comment-avatar"
                                                                style={{
                                                                    background: '#898989',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: '#FFFFFF',
                                                                    fontSize: '18px',
                                                                    fontFamily: "Roboto-Regular"
                                                                }}
                                                            >
                                                                {item.user_name?.charAt(0).toUpperCase()}
                                                            </div>
                                                        )}
                                                        <div className="comment-content">
                                                            <div className="comment-header">
                                                                <strong>{item.user_name}</strong>
                                                                {/* <span className="comment-time">2 Min</span> */}
                                                            </div>
                                                            <p>{item.comment}</p>
                                                            <div className="comment-actions">
                                                                <div className="likes-repli-div" onClick={() => setDownloadPopupOpen(true)}>
                                                                    <img src={hearticon} alt="heart icon" className="comment-likes-icon" />
                                                                    <span>{item.comment_likes_count > 0 ? item.comment_likes_count : ''}</span>
                                                                    <p className="post-vertical-line">|</p>
                                                                    <button>Reply</button>
                                                                </div>
                                                                {/* <div className="view-repli-div">
                                                                    <button>View Reply</button>
                                                                    <img src={viewreplyicon} alt="view reply" className="view-repli-icon" />
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <p style={{ textAlign: 'center', color: '#999' }}>No comments yet</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </main>
            </div >

            {postpopup && (
                <div className="popup-overlay" onClick={() => setPostpopup(false)}>
                    <div className="popup-box" ref={popupRef} onClick={(e) => e.stopPropagation()}>
                        <div className="popup-options">
                            <Link to="/HomeCarouselOffer" className="remove-underline">
                                <div className="popup-item">
                                    <img src={campopup} alt="Post" />
                                    <p>Post</p>
                                </div>
                            </Link>

                            <div className="popup-item">
                                <img src={vidpopup} alt="Video" />
                                <p>Video</p>
                            </div>

                            <div className="popup-item">
                                <img src={carouselpopup} alt="Carousel" />
                                <p>Carousel</p>
                            </div>

                            <div className="popup-item">
                                <img src={offerpopup} alt="Offer" />
                                <p>Offer</p>
                            </div>

                            <div className="popup-item">
                                <img src={spotlightpopup} alt="Spotlight" />
                                <p>Spotlight</p>
                            </div>

                            <div className="popup-item">
                                <img src={eventpopup} alt="Event" />
                                <p>Event</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {downloadPopupOpen && (
                <>
                    <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                    <div className="download-popup-drawer">
                        <div className="pop-up-img">
                            <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                        </div>
                        <div className="popup-header">
                            <div className="pop-up-download">
                                <div className="hayaticon">
                                    <img src={hayatlogo} alt="Hayat In Logo" />
                                    <div className="close-btn">
                                        <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                    </div>
                                </div>
                                <h4 className="download-hayat">Download Our App </h4>
                                <p id="App-description">
                                    Scan the QR code with your phone and open Hayat In instantly
                                    Your gateway to discovering the city in one tap.                                </p>

                                <div className="store-buttons">
                                    <div className="app_qr">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="App Store" />
                                        </a>

                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Google Play" />
                                        </a>
                                    </div>


                                    <div className="app_qr">
                                        <img className="qr" src={qr} alt="QR code" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            )}
        </div >
    )
};

export default VideoPost